import React from 'react';
import WarningContractBlockDialog from './WarningContractBlockDialog';
import WarningContractBlockService from '../../services/WarningContractBlockService';
import { observer } from 'mobx-react';

class WarningContractBlockDialogContainer extends React.Component {
  constructor(props) {
    super(props);
    this.warningContractBlockService = new WarningContractBlockService();
  }

  componentDidMount() {
    this.warningContractBlockService.load();
  }

  render() {
    return (
      <WarningContractBlockDialog
        isOpen={this.warningContractBlockService.isOpen}
        onClose={this.warningContractBlockService.close}
        overdueBills={this.warningContractBlockService.overdueBills}
        daysUntilBlock={this.warningContractBlockService.daysUntilBlock}
      />
    );
  }
}

export default observer(WarningContractBlockDialogContainer);
